export { DetailContent } from "./DetailContent";
export { IDetailContentProps } from "./types";
